<!-- task-card.component.html -->
<a [routerLink]="consultaionDetailsLink">
	<div class="card tasks-box mb-2">
		<a>
			<div class="card-body" [routerLink]="consultaionDetailsLink">
				<div class="d-flex mb-3">
					<a [routerLink]="consultaionDetailsLink" href="javascript:void(0)" class="text-muted fw-medium fs-14 flex-grow-1">{{ consultationNumero }}</a>
				</div>

				<h6 class="fs-15 text-truncate task-title mb-0">
					<a [routerLink]="consultaionDetailsLink" class="d-block">{{ consultaionTitle }}</a>
				</h6>
			</div>
			<div class="card-footer border-top-dashed">
				<div class="d-flex">
					<div class="flex-grow-1">
						<span class="text-muted"><i class="ri-time-line align-bottom"></i> {{ consultaionDate }}</span>
					</div>
					<div class="flex-shrink-0">
						<ul class="link-inline mb-0 p-0">
							<li class="list-inline-item">
								<a href="javascript:void(0)" class="text-muted"><i class="ri-shopping-basket-line align-bottom"></i> {{ articlesCount }}</a>
							</li>
						</ul>
					</div>
				</div>
			</div>
		</a>
	</div>
</a>
